import { atom } from "~/observers/jotai";

import type { ListStudentsDTO } from "./types";
import { defaultListValue } from "./variables";

export const studentsAtom = atom<ListStudentsDTO>(defaultListValue);
